import {
  IBulkManualRateUpdate,
  IRatePlanConf,
  ISuggestedBaseRateUpdate,
} from "./../../../models/api.models";
import { YieldApi } from "../../../api/yield";
import { UserApi } from "../../../api/user";
import { OtaApi } from "../../../api/ota";
import { events as gnEvent } from "gn-shared";
import { ConfigApi } from "api/config";

const revanista: any = {
  files: {
    getUploadLink: async (
      hotelId: number,
      contentType: string,
      fileExtension: string,
      filename: string,
    ) => {
      return await YieldApi.getUploadLink({
        hotelId,
        fileExtension,
        contentType,
        filename,
      });
    },

    upload: async (url: string, contentType: string, data: string) => {
      return await YieldApi.uploadFile({ url, contentType, data });
    },

    delete: async (hotelId: number, filename: string) => {
      return await YieldApi.deleteFile({ hotelId, filename });
    },
  },
  hotel: {
    updateMonthlyPopupValue: async (userEmail: string, hotelIds: number) => {
      return await UserApi.updateMonthlyPopupValue({
        userEmail,
        hotelIds,
      });
    },

    remindMeLater: async (userEmail: string, hotelIds: number) => {
      return await UserApi.remindMeLater({
        userEmail,
        hotelIds,
      });
    },
    getAttribute: async (token: string) => {
      return await UserApi.getAttribute(token);
    },
    getCompSetList: async (hotelId: number) => {
      return await OtaApi.getOtaHotelCompList(hotelId);
    },
    putExecSummaryItem: async (item: any) => {
      return await YieldApi.putExecSummaryItem(item);
    },
    deleteRateplan: async (id: string, hotelId: number) => {
      return await ConfigApi.deleteRateplan({ id, hotelId });
    },
    deleteRoomType: async (rtId: string, hotelId: number) => {
      return await ConfigApi.deleteRoomType({ rtId, hotelId });
    },
    writeRateplan: async (rp: any, hotelId: number) => {
      const body = rp;
      body.hotelId = hotelId;
      return await ConfigApi.writeRateplan(body as IRatePlanConf);
    },
  },
  yieldsheet: {
    notify: {
      event: async (hotelId: number, event: string) => {
        return await YieldApi.notify({
          hotelId,
          type: gnEvent.notificationType.event,
          event,
        });
      },
      suggestedBR: async (hotelId: number) => {
        return await YieldApi.notify({
          hotelId,
          type: gnEvent.notificationType.suggestions,
        });
      },
    },
    days: {
      bulkUpdateManualRates: async (payload: IBulkManualRateUpdate) => {
        return await YieldApi.bulkUpdateManualRates(payload);
      },
      updateSuggestedBaseRate: async (payload: ISuggestedBaseRateUpdate[]) => {
        const res = await YieldApi.updateSuggestedBaseRate(payload);
        return res;
      },
    },
  },
};

const YieldSheetService = {
  revanista: revanista,
};

export { YieldSheetService };
